import script from "./NoticeBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&setup=true&lang=js"

import "./NoticeBoard.vue?vue&type=style&index=0&id=301b9c2a&lang=css"

const __exports__ = script;

export default __exports__